import React from "react";
import classes from "./auth.module.css";
import Card from "./Card";
import Login from "./Login";
import Register from "./Register";
import Reset from "./Reset";
import { useHistory } from "react-router-dom";
import OTP from "./otp";
import SetPassword from "./setPassword";
const Auth = (props) => {
  const history = useHistory();
  let plugin = null;
  const { pathname } = history.location;
  if (pathname === "/register") plugin = <Register />;
  else if (pathname === "/forgot-password") plugin = <Reset />;
  else if (pathname === "/verify") plugin = <OTP />;
  else if (pathname === "/reset") plugin = <SetPassword />;
  else plugin = <Login setAuth={props.setAuth} />;

  let toRender = (
    <div className={classes.auth}>
      <div className={classes.left}>
        {/* <img alt="companyLogo" className={classes.logo} src="/images/logo.svg"></img> */}
        <img alt="authScreenImage" className={classes.image} src="/images/image.svg"></img>
        <Card extraClass={classes.card}>{plugin}</Card>
      </div>
      <div className={classes.right}></div>
    </div>
  );

  if (window.innerWidth <= 870) {
    toRender = (
      <Card>

        {/* <img className={classes.logo} src="/images/logo.svg"></img> */}
         {plugin}
      </Card>
    );
  }
  return toRender;
};

export default Auth;
